import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import { SnackbarProvider } from 'notistack'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import util from 'util'
import inherits from 'inherits'
import App from './App'
import reportWebVitals from './reportWebVitals'
import MaterialUITheme from './MaterialUITheme'
import { firebase, signInFirebase } from './firebase/firebase'

window.util = util
util.inherits = inherits
window.util.inherits = inherits
const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <ThemeProvider theme={MaterialUITheme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={4}>
        <App />
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>,
)

// Remove service worker registration if not needed
// serviceWorkerRegistration.register()
signInFirebase()
reportWebVitals()
